module.exports = __webpack_public_path__ + "static/media/eggs_stamp_fr.d16fe22c.svg";